import React, { useState, useEffect,useCallback  } from 'react';
import {
  Card, Row, Col, Statistic, Typography, Layout, theme,
  Progress, Space, Spin, FloatButton, DatePicker, Button
} from 'antd';
import {
  CheckCircleOutlined, WarningOutlined, FolderOpenOutlined,
  PauseCircleOutlined, CloseCircleOutlined, UserOutlined,
  ClockCircleOutlined, CalendarOutlined, SyncOutlined,
  UpOutlined, DashboardOutlined, FileTextOutlined
} from '@ant-design/icons';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid,
  Tooltip as RechartsTooltip, ResponsiveContainer
} from 'recharts';
import api from '../api/Api';
import dayjs from 'dayjs';

const { Title, Text } = Typography;
const { Content } = Layout;
const { useToken } = theme;
const { RangePicker } = DatePicker;

const DashboardTarefas = () => {
  const { token } = useToken();

  // Estado
  const [dateRange, setDateRange] = useState([
    dayjs().startOf('month'),
    dayjs()
  ]);
  const [loading, setLoading] = useState(false);
  const [tarefasData, setTarefasData] = useState({
    total: 0, aberta: 0, fechada: 0,
    suspenso: 0, foraPrazo: 0, rejeitada: 0
  });
  const [indicadoresData, setIndicadoresData] = useState(null);
  const [tarefasMensais, setTarefasMensais] = useState([]);


  const fetchData = useCallback(async () => {
   
    setLoading(true);
    const userStored = JSON.parse(localStorage.getItem("user"));
    try {
 


      const inicio = dateRange?.[0] || dayjs().startOf('month');
      const fim = dateRange?.[1] || dayjs();
  
      const dataInicio = inicio.format('YYYY-MM-DD');
      const dataFim = fim.format('YYYY-MM-DD');

 


      const payload = {
      dataInicio: dataInicio,
     dataFim: dataFim,
        id_user: userStored.id,
        employee_id: userStored.employee_id
      };

      const [tarefasRes, indicadoresRes, tarefasFechadasRes] = await Promise.all([
        api.ListTarefasUser(payload),
        api.ListIndicadoresUser(payload),
        api.ListTarefasFechadasMesUser(payload)
      ]);

      setTarefasData(tarefasRes || {
        total: 0, aberta: 0, fechada: 0,
        suspenso: 0, foraPrazo: 0, rejeitada: 0
      });
      setIndicadoresData(indicadoresRes?.[0] || null);
      setTarefasMensais(tarefasFechadasRes || []);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoading(false);
    }
  }, [dateRange]); // ← depende de dateRange

  // 2. Título só no mount
  useEffect(() => {
    document.title = "Dashboard de Tarefas - TECH NEXT CRM";
  }, []);

  // 3. Dispara no mount e ao mudar dateRange
  useEffect(() => {
    fetchData();
  }, [fetchData]);

 
  // ==================== CARDS DE TAREFAS ====================
  const TarefasStatCards = () => {
    const completionPercent = tarefasData.total > 0
      ? Math.round((tarefasData.fechada / tarefasData.total) * 100)
      : 0;
    const overduePercent = tarefasData.total > 0
      ? Math.round((tarefasData.foraPrazo / tarefasData.total) * 100)
      : 0;

    return (
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        {/* Total */}
        <Col xs={24} sm={12} lg={8}>
          <Card hoverable style={{
            background: `linear-gradient(135deg, ${token.colorPrimary} 0%, ${token.colorPrimaryActive} 100%)`,
            borderRadius: '12px', border: 'none',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)', height: '100%'
          }} bodyStyle={{ padding: '20px' }}>
            <Statistic
              title={
                <Space style={{ color: 'white', opacity: 0.9 }}>
                  <FileTextOutlined />
                  <Text style={{ color: 'white' }}>Total de Tarefas</Text>
                </Space>
              }
              value={tarefasData.total}
              valueStyle={{ color: 'white', fontSize: '32px', fontWeight: 'bold' }}
              prefix={<FileTextOutlined />}
            />
            <div style={{ marginTop: '12px' }}>
              <Progress percent={completionPercent} strokeColor="white"
                trailColor="rgba(255,255,255,0.2)" showInfo={false} size="small" />
              <Text style={{ color: 'white', fontSize: '12px', display: 'block', marginTop: 4 }}>
                {completionPercent}% concluídas
              </Text>
            </div>
          </Card>
        </Col>

        {/* Concluídas */}
        <Col xs={24} sm={12} lg={8}>
          <Card hoverable style={{
            background: `linear-gradient(135deg, ${token.colorSuccess} 0%, ${token.colorSuccessActive} 100%)`,
            borderRadius: '12px', border: 'none',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)', height: '100%'
          }} bodyStyle={{ padding: '20px' }}>
            <Statistic
              title={
                <Space style={{ color: 'white', opacity: 0.9 }}>
                  <CheckCircleOutlined />
                  <Text style={{ color: 'white' }}>Concluídas</Text>
                </Space>
              }
              value={tarefasData.fechada}
              valueStyle={{ color: 'white', fontSize: '32px', fontWeight: 'bold' }}
              prefix={<CheckCircleOutlined />}
            />
            <div style={{ marginTop: '12px' }}>
              <Progress percent={completionPercent} strokeColor="white"
                trailColor="rgba(255,255,255,0.2)" showInfo={false} size="small" />
            </div>
          </Card>
        </Col>

        {/* Fora do Prazo */}
        <Col xs={24} sm={12} lg={8}>
          <Card hoverable style={{
            background: `linear-gradient(135deg, ${token.colorWarning} 0%, ${token.colorWarningActive} 100%)`,
            borderRadius: '12px', border: 'none',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)', height: '100%'
          }} bodyStyle={{ padding: '20px' }}>
            <Statistic
              title={
                <Space style={{ color: 'white', opacity: 0.9 }}>
                  <WarningOutlined />
                  <Text style={{ color: 'white' }}>Fora do Prazo</Text>
                </Space>
              }
              value={tarefasData.foraPrazo}
              valueStyle={{ color: 'white', fontSize: '32px', fontWeight: 'bold' }}
              prefix={<WarningOutlined />}
            />
            <div style={{ marginTop: '12px' }}>
              <Progress percent={overduePercent} strokeColor="white"
                trailColor="rgba(255,255,255,0.2)" showInfo={false} size="small" />
            </div>
          </Card>
        </Col>
      </Row>
    );
  };

  // Cards secundários (abertas, suspensas, rejeitadas)
  const AdditionalTarefasCards = () => (
    <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
      <Col xs={24} sm={8} md={8}>
        <Card size="small" hoverable>
          <Statistic
            title="Abertas"
            value={tarefasData.aberta}
            prefix={<FolderOpenOutlined />}
            valueStyle={{ color: token.colorPrimary }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={8} md={8}>
        <Card size="small" hoverable>
          <Statistic
            title="Suspensas"
            value={tarefasData.suspenso}
            prefix={<PauseCircleOutlined />}
            valueStyle={{ color: token.colorWarning }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={8} md={8}>
        <Card size="small" hoverable>
          <Statistic
            title="Rejeitadas"
            value={tarefasData.rejeitada}
            prefix={<CloseCircleOutlined />}
            valueStyle={{ color: token.colorError }}
          />
        </Card>
      </Col>
    </Row>
  );

  // ==================== INDICADORES DO USUÁRIO ====================
  const cardStyle = {
  borderRadius: '12px',
  height: '120px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
};
  const IndicadoresCards = () => {
    if (!indicadoresData) return null;

    return (
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={24} sm={12} md={6}>
          <Card hoverable size="small" style={cardStyle}>
            <Statistic
              title="Assiduidade"
              value={indicadoresData.assiduidade}
              prefix={<UserOutlined />}
              valueStyle={{ color: token.colorSuccess }}
            />
            <Progress
              percent={parseInt(indicadoresData.assiduidade) || 0}
              strokeColor={token.colorSuccess}
              size="small"
              showInfo={false}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card hoverable size="small" style={cardStyle}>
            <Statistic
              title="Pontualidade"
              value={indicadoresData.pontualidade}
              prefix={<ClockCircleOutlined />}
              valueStyle={{ color: token.colorPrimary }}
            />
            <Progress
              percent={parseInt(indicadoresData.pontualidade) || 0}
              strokeColor={token.colorPrimary}
              size="small"
              showInfo={false}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card hoverable size="small" style={cardStyle}>
            <Statistic
              title="Faltas"
              value={indicadoresData.faltas}
              prefix={<WarningOutlined />}
              valueStyle={{ color: token.colorWarning }}
              suffix={
                <Text type="secondary" style={{ fontSize: 14 }}>
                  ({indicadoresData.faltas_justificadas} justif.)
                </Text>
              }
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card hoverable size="small" style={cardStyle}>
            <Statistic
              title="Dias Trabalhados"
              value={`${indicadoresData.dias_trabalhados} / ${indicadoresData.dias_uteis}`}
              prefix={<CalendarOutlined />}
              valueStyle={{ color: token.colorInfo }}
              suffix="dias"
            />
          </Card>
        </Col>
      </Row>
    );
  };

  // ==================== GRÁFICO MENSAL (ÁREA) ====================
  const TarefasMensaisChart = () => (
    <Card
      title={
        <Space>
          <CalendarOutlined />
          <span>Tarefas Concluídas por Mês</span>
        </Space>
      }
      style={{ borderRadius: '12px', marginBottom: '24px' }}
      hoverable
    >
      <div style={{ height: '350px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={tarefasMensais}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorTarefasMes" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={token.colorPrimary} stopOpacity={0.8} />
                <stop offset="95%" stopColor={token.colorPrimary} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke={token.colorBorder} />
            <XAxis
              dataKey="mes"
              tick={{ fill: token.colorTextSecondary }}
              axisLine={{ stroke: token.colorBorder }}
            />
            <YAxis
              tick={{ fill: token.colorTextSecondary }}
              axisLine={{ stroke: token.colorBorder }}
              allowDecimals={false}
            />
            <RechartsTooltip
              contentStyle={{
                backgroundColor: token.colorBgContainer,
                border: `1px solid ${token.colorBorder}`,
                borderRadius: '8px'
              }}
            />
            <Area
              type="monotone"
              dataKey="total"
              stroke={token.colorPrimary}
              fillOpacity={1}
              fill="url(#colorTarefasMes)"
              strokeWidth={2}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );

  // ==================== RENDER PRINCIPAL ====================
  return (
    <Layout style={{ minHeight: '100vh', background: token.colorBgLayout }}>
      <Content style={{ padding: '24px', overflow: 'auto', height: '100vh' }}>
        {/* Overlay de carregamento */}
        {loading && (
          <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(255,255,255,0.7)', display: 'flex',
            justifyContent: 'center', alignItems: 'center', zIndex: 1000
          }}>
            <Spin size="large" tip="Carregando dados..." />
          </div>
        )}

        {/* Cabeçalho com título e seletor de período */}
        <div style={{
          marginBottom: '24px', display: 'flex',
          justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: '16px'
        }}>
         
          <Space>
            <RangePicker
              value={dateRange}
              onChange={(dates) => setDateRange(dates)}
              format="DD/MM/YYYY"
              allowClear={false}
            />
            <Button
              icon={<SyncOutlined />}
              onClick={fetchData}
              loading={loading}
            >
              Atualizar
            </Button>
          </Space>
        </div>

        {/* Conteúdo dos cards e gráfico */}
        <TarefasStatCards />
        <AdditionalTarefasCards />

        <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
          <Col xs={24}>
            <TarefasMensaisChart />
          </Col>
        </Row>

        <IndicadoresCards />

        {/* Botões flutuantes */}
        <FloatButton.BackTop
          icon={<UpOutlined />}
          style={{ right: 24, bottom: 24 }}
          visibilityHeight={300}
        />
        <FloatButton
          icon={<SyncOutlined spin={loading} />}
          onClick={fetchData}
          tooltip="Atualizar dados"
          style={{ right: 24, bottom: 80 }}
        />
      </Content>
    </Layout>
  );
};

export default DashboardTarefas;